import { IndicatorsData } from "./components/PVSystForm";
import { PVSyst, PostUsina } from "./types";

export function usinaToFormIndicatorCalculation(
  usina: PostUsina | null,
): IndicatorsData | undefined {
  if (!usina) {
    return undefined;
  }
  const indicatorsData: IndicatorsData = {
    nameUsina: usina.name ?? "",
    codeUsina: usina.code ?? "",
    kWac: usina.indicators?.totalPower ?? undefined,
    invertersAmount: usina.components?.inverters?.amount ?? undefined,
    invertersFullPower: usina.components?.inverters?.inverterPower ?? undefined,
    latitude: usina.location?.latitude ?? undefined,
    longitude: usina.location?.longitude ?? undefined,
    prPredicted: usina.indicators?.pr ?? undefined,
    moduleArea: usina.indicators?.modulesArea ?? undefined,
    moduleEfficiency: usina.indicators?.efficiency ?? undefined,
    irradiance: usina.indicators?.irradiance ?? undefined,
    globInc: usina.indicators?.globInc ?? undefined,
    eGridPredicted: usina.indicators?.predictedEnergy ?? undefined,
    variance: usina.indicators?.variance ?? undefined,
    kWpico: usina.indicators?.kwPeak ?? undefined,
    opticalLossesPercentage:
      usina.indicators?.opticalLossesPercentage ?? undefined,
    conversionLossesPercentage:
      usina.indicators?.conversionLossesPercentage ?? undefined,
    inverterLossesPercentage:
      usina.indicators?.inverterLossesPercentage ?? undefined,
    transformerLossesPercentage:
      usina.indicators?.transformerLossesPercentage ?? undefined,
    pvSystExpectedOpticalLoss:
      usina.indicators?.pvSystExpectedOpticalLoss ?? undefined,
    pvSystExpectedConversionLoss:
      usina.indicators?.pvSystExpectedConversionLoss ?? undefined,
    pvSystExpectedInverterLoss:
      usina.indicators?.pvSystExpectedInverterLoss ?? undefined,
    pvSystExpectedTransformerLoss:
      usina.indicators?.pvSystExpectedTransformerLoss ?? undefined,
    pvSystExpectedSystem: usina.indicators?.pvSystExpectedSystem ?? undefined,
    pvSystExpectedContractual:
      usina.indicators?.pvSystExpectedContractual ?? undefined,
    pvSystExpectedInverter:
      usina.indicators?.pvSystExpectedInverter ?? undefined,
  };
  return indicatorsData;
}

export function formIndicatorCalculationToUsina(
  indicators: IndicatorsData,
): PostUsina | null {
  if (!indicators) {
    return null;
  }
  const usina: PostUsina = {
    indicators: {
      efficiency: indicators.moduleEfficiency ?? undefined,
      kwPeak: indicators.kWpico ?? undefined,
      irradiance: indicators.irradiance ?? undefined,
      globInc: indicators.globInc ?? undefined,
      modulesArea: indicators.moduleArea ?? undefined,
      pr: indicators.prPredicted ?? undefined,
      predictedEnergy: indicators.eGridPredicted ?? undefined,
      totalPower: indicators.kWac ?? undefined,
      variance: indicators.variance ?? undefined,
      opticalLossesPercentage: indicators.opticalLossesPercentage ?? undefined,
      conversionLossesPercentage:
        indicators.conversionLossesPercentage ?? undefined,
      inverterLossesPercentage:
        indicators.inverterLossesPercentage ?? undefined,
      transformerLossesPercentage:
        indicators.transformerLossesPercentage ?? undefined,
      pvSystExpectedOpticalLoss:
        indicators.pvSystExpectedOpticalLoss ?? undefined,
      pvSystExpectedConversionLoss:
        indicators.pvSystExpectedConversionLoss ?? undefined,
      pvSystExpectedInverterLoss:
        indicators.pvSystExpectedInverterLoss ?? undefined,
      pvSystExpectedTransformerLoss:
        indicators.pvSystExpectedTransformerLoss ?? undefined,
      pvSystExpectedSystem: indicators.pvSystExpectedSystem ?? undefined,
      pvSystExpectedContractual:
        indicators.pvSystExpectedContractual ?? undefined,
      pvSystExpectedInverter: indicators.pvSystExpectedInverter ?? undefined,
    },
    location: {
      latitude: indicators.latitude ?? undefined,
      longitude: indicators.longitude ?? undefined,
    },
    name: indicators.nameUsina ?? undefined,
    code: indicators.codeUsina ?? undefined,
    components: {
      inverters: {
        inverterPower: indicators.invertersFullPower ?? undefined,
        amount: indicators.invertersAmount ?? undefined,
      },
    },
  };
  return usina;
}

export function PVSystToUsina(pvSyst: PVSyst | null): PostUsina | null {
  if (!pvSyst) return null;
  const usina: PostUsina = {
    components: {
      inverters: {
        amount: pvSyst.inverterNumber ?? undefined,
        inverterPower: pvSyst.inverterUnitNomPower ?? undefined,
      },
      modules: {
        amount: pvSyst.moduleNumber ?? undefined,
        power: pvSyst.moduleUnitNomPower ?? undefined,
      },
      string: {
        amount: pvSyst.stringNumber ?? undefined,
      },
    },
    indicators: {
      modulesArea: pvSyst.module_area ?? undefined,
      pr: pvSyst.pr ?? undefined,
      totalPower: pvSyst.inverterTotalPower ?? undefined,
      irradiance: pvSyst.globInc ?? undefined,
      globInc: pvSyst.globInc ?? undefined,
      predictedEnergy: pvSyst.e_Grid ?? undefined,
      kwPeak: pvSyst.nominal_STC ?? undefined,
    },
    location: {
      latitude: pvSyst.latitude ?? undefined,
      longitude: pvSyst.longitude ?? undefined,
    },
  };
  return usina;
}
